<div class="panel">
  <div class="head">
    <h3>{{ titleKey ? (titleKey | translate) : result.key }}</h3>

    <button type="button" class="x" (click)="close()" [attr.aria-label]="'close' | translate">✕</button>
  </div>
  <!-- Only on metrics whose evidence isn't notApplicable; see basisLabelKey. -->
  <div class="basis" *ngIf="basisLabelKey">{{ basisLabelKey | translate }}</div>
  <div class="basis" *ngIf="derivedMoney">{{ 'dashboard.w.contribution_sub' | translate }}</div>

  <table class="drill-table" *ngIf="columns.length">
    <tr>
      <th *ngFor="let col of columns" [class.num]="isNumCol(col)">{{ label(col) }}</th>
    </tr>
    <tr *ngFor="let row of tableRows">
      <td *ngFor="let col of columns" [class.num]="isNum(row[col])">
        <a *ngIf="col === 'name' && row['userId']; else plainCell" class="row-link" href="javascript:void(0)" (click)="openUser(row['userId'])">{{ row[col] }}</a>
        <ng-template #plainCell>{{ formatValue(col, row[col]) }}</ng-template>
      </td>
    </tr>
  </table>
  <div class="more-rows" *ngIf="moreCount > 0">{{ 'dashboard.drill.more_rows' | translate:{n: moreCount} }}</div>

  <table class="drill-table" *ngIf="flatEntries.length">
    <tr *ngFor="let e of flatEntries">
      <th>{{ e.label }}</th>
      <td [class.num]="isNum(e.value)">{{ formatValue(e.key, e.value) }}</td>
    </tr>
  </table>

  <button nbButton status="primary" *ngIf="hasSource" (click)="openSource()">{{ sourceLabelKey | translate }}</button>
</div>
